<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="loadForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="load" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    import frameTypeEnum from '../enums/frameType'

    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                loadForm: () => import('../forms/LoadForm'),
                load: () => import('../editViews/Load'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Name', value: 'name' },
                    { text: 'Number Of Frames', value: 'numberOfFrames' },
                    { text: 'Frame Types', value: 'frameTypes', formatEnum: frameTypeEnum },
                    { text: 'Site', value: 'siteId', table: 'sites' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    members: [],
                    sites: [],
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                    { column: "memberId", direction: "ascending" },
                ],
                itemsField: 'loads',
                editPageName: 'load',
                apiMethod: 'Loads',
                claimName: 'Loads',
                formTitle: 'Load',
                excelTitle: 'Loads',
                hasEditPage: true,
            }
        },
    };
</script>
